import { ApiEndpoints } from "../apiEndpoints";
import { requestApi } from "../apiService";

export const uploadImage = async (
  file: Blob | File,
  filename: string,
): Promise<string> => {
  const response = await requestApi({
    url: ApiEndpoints.IMAGES,
    method: "POST",
    headers: { "Content-Type": "application/octet-stream" },
    params: {
      filename,
    },
    data: file,
  });

  return response.data;
};

export const deleteImage = async (id: string): Promise<string> => {
  const response = await requestApi({
    url: `${ApiEndpoints.IMAGES}/${id}`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  });

  return response.data;
};
